/**
 * @generated SignedSource<<62b7e421a88a9abba6a2e1cf9adb6274>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type topicAdsTopic$data = {
  readonly advertZone: string | null | undefined;
  readonly entityId: string;
  readonly " $fragmentType": "topicAdsTopic";
};
export type topicAdsTopic$key = {
  readonly " $data"?: topicAdsTopic$data;
  readonly " $fragmentSpreads": FragmentRefs<"topicAdsTopic">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "topicAdsTopic",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "entityId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "version",
          "value": 2
        }
      ],
      "kind": "ScalarField",
      "name": "advertZone",
      "storageKey": "advertZone(version:2)"
    }
  ],
  "type": "Topic",
  "abstractKey": null
};

(node as any).hash = "4acbcc711778a4d8a557b064dead51f7";

export default node;
